import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="/images/logo.png" 
              alt="Reclaim Pest Control" 
              className="h-10 md:h-14"
            />
            <div>
              <span className="text-lg md:text-2xl font-bold text-gray-800">Reclaim</span>
              <span className="text-lg md:text-2xl font-bold text-green-600"> Pest Control</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-blue-600 font-medium">Home</Link>
            <Link to="/services" className="text-gray-700 hover:text-blue-600 font-medium">Services</Link>
            <Link to="/service-areas" className="text-gray-700 hover:text-blue-600 font-medium">Service Areas</Link>
            <Link to="/about" className="text-gray-700 hover:text-blue-600 font-medium">About</Link>
            <Link to="/blog" className="text-gray-700 hover:text-blue-600 font-medium">Blog</Link>
            <Link to="/faq" className="text-gray-700 hover:text-blue-600 font-medium">FAQ</Link>
            <Link to="/contact" className="bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700 transition">Contact Us</Link>
          </nav>

          {/* Phone Number - Desktop + Mobile */}
          <a href="tel:6462099955" className="hidden md:flex items-center bg-green-600 text-white px-4 py-2 rounded-lg font-bold text-base hover:bg-green-700 transition shadow-sm" data-testid="header-call-btn">
            <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20"><path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/></svg>
            (646) 209-9955
          </a>

          {/* Mobile compact call button */}
          <a href="tel:6462099955" className="md:hidden bg-green-600 text-white px-3 py-2 rounded-lg font-bold text-sm flex items-center mr-2" data-testid="header-mobile-call-btn">
            <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20"><path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/></svg>
            Call
          </a>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-gray-700 focus:outline-none"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden pb-4 space-y-2">
            <Link to="/" className="block py-2 text-gray-700 hover:text-blue-600">Home</Link>
            <Link to="/services" className="block py-2 text-gray-700 hover:text-blue-600">Services</Link>
            <Link to="/service-areas" className="block py-2 text-gray-700 hover:text-blue-600">Service Areas</Link>
            <Link to="/about" className="block py-2 text-gray-700 hover:text-blue-600">About</Link>
            <Link to="/blog" className="block py-2 text-gray-700 hover:text-blue-600">Blog</Link>
            <Link to="/faq" className="block py-2 text-gray-700 hover:text-blue-600">FAQ</Link>
            <Link to="/contact" className="block py-2 text-gray-700 hover:text-blue-600">Contact</Link>
            <a href="tel:6462099955" className="block py-2 text-blue-600 font-bold">📞 (646) 209-9955</a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;